import React, { useState } from "react";

const SliderComponent = ({ setCurrentView }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideDirection, setSlideDirection] = useState("next");
  const [currentTenetSlide, setCurrentTenetSlide] = useState(0);
  const [tenetSlideDirection, setTenetSlideDirection] = useState("next");

  const tenets = [
    {
      subtitle: "Tenet 1 - Empathy:",
      subdescription:
        "Deeply understand and relate to the emotions, perspectives, and needs of others, whether employees, clients, or stakeholders. This will help foster stronger relationships, increase emotional intelligence, and build a supportive team culture.",
      image: "./assets/images/bus-empathy-img.jpg",
    },
    {
      subtitle: "Tenet 2 - Active Observation:",
      subdescription:
        "Be fully aware of and attentive to subtle cues, behaviors, or environmental factors that provide insight into team dynamics, project progress, or potential problems. This will help spot issues early, understand team strengths and weaknesses, and adjust their approach as needed.",
      image: "./assets/images/bus-observation.jpg",
    },
    {
      subtitle: "Tenet 3 - Check for High Stakes:",
      subdescription:
        "To evaluate the potential consequences of decisions or situations to determine if the stakes are high, and adjust actions based on the risk involved. This ensures that resources, time, and attention are allocated proportionate to the significance of a situation.",
      image: "./assets/images/bus-stakes-img.jpg",
    },
    {
      subtitle: "Tenet 4 - Identify Varying Opinions:",
      subdescription:
        "To actively recognize and consider the diverse opinions, viewpoints, and feedback from team members or stakeholders. This will help grow inclusivity, spark creativity, and lead to better decision-making, helping managers achieve improved outcomes.",
      image: "./assets/images/bus-opinion-img.jpg",
    },
  ];

  // Slider content array
  const slides = [
    {
      title: "About the Company",
      description: [
        "In this simulation you are an employee at Vanmat Manufacturing Ltd. (VML).",
        "VML is a manufacturing engineering solutions provider offering manufacturing solutions across various industries. VML ensures effective team management through consistent feedback and clarity in communication.",
        "The organization’s culture encourages sharing open and constructive feedback that will help the employees grow.",
      ],
      image: "./assets/images/bus-company-img.jpg",
    },
    {
      title: "About the team",
      description: [
        "You have joined VML an year ago. You are working on a major project.",
        "Three other associates work under you. You will face situations where you need to critically analyse and then overcome the challenges within your team.",
        "To do this, you must prepare by reading each scenario carefully and responding them in a detailed manner",
      ],
      image: "./assets/images/bus-about-team.jpg",
    },
    {
      title: "Your Objectives",
      description: [
        "Based on your responses, this simulation will determine your proficiency",
        "on the following 4 tenets:",
      ],
      isTenetSlide: true,
    },
    {
      title: "Your Objective",
    },
  ];

  console.log(slides.length);

  // Handle navigation
  const handleNext = () => {
    if (currentSlide === 2) {
      if (currentTenetSlide < tenets.length - 1) {
        setTenetSlideDirection("next");
        setCurrentTenetSlide((prev) => prev + 1);
        return;
      }
    }
    setSlideDirection("next");
    setCurrentSlide((prev) => (prev + 1) % slides.length); // Loop back to first slide
    setCurrentTenetSlide(0);
  };

  const handlePrevious = () => {
    if (currentSlide === 2) {
      if (currentTenetSlide > 0) {
        setTenetSlideDirection("prev");
        setCurrentTenetSlide((prev) => prev - 1);
        return;
      }
    }
    setSlideDirection("prev");
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length); // Loop back to last slide
    setCurrentTenetSlide(tenets.length - 1);
  };

  const TenetContent = ({ tenet }) => (
    <div
      style={{
        display: "flex",
        backgroundColor: "white",
        borderRadius: "50px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        width: "80%",
        overflow: "hidden",
        margin: "20px auto",
        justifyContent: "space-around",
        height: "350px",
      }}
      className={`tenet-slide ${tenetSlideDirection}`}
    >
      <div style={{ padding: "40px 20px", maxWidth: "45%", flex: 1 }}>
        <h2
          style={{
            fontSize: "1.25rem",
            color: "#333",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          {tenet.subtitle}
        </h2>
        <p
          style={{
            fontSize: "1.25rem",
            lineHeight: "1.25",
            color: "#666",
          }}
        >
          {tenet.subdescription}
        </p>
      </div>
      <div
        style={{
          flex: "0 0 450px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: "40px 20px",
        }}
      >
        <img
          src={tenet.image}
          alt={tenet.subtitle}
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "400px",
            borderRadius: "10%",
          }}
        />
      </div>
    </div>
  );

  const currentContent = slides[currentSlide];

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        backgroundImage: "url('./assets/images/home-banner.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <style>
        {`
          @keyframes slideInNext {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes slideInPrev {
            from {
              transform: translateX(-100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          .slide-content {
            animation: ${
              slideDirection === "next" ? "slideInNext" : "slideInPrev"
            } 0.5s forwards;
          }

          .tenet-slide {
            animation: ${
              tenetSlideDirection === "next" ? "slideInNext" : "slideInPrev"
            } 0.5s forwards;
          }
          
          .nav-button {
            transition: transform 0.2s ease;
          }
          
          .nav-button:hover {
            transform: scale(1.1);
          }
        `}
      </style>
      <style>
        {`
          @keyframes slideInNext {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes slideInPrev {
            from {
              transform: translateX(-100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          .slide-content {
            animation: ${
              slideDirection === "next" ? "slideInNext" : "slideInPrev"
            } 0.5s forwards;
          }

          .nav-button {
            transition: transform 0.2s ease;
          }

          .nav-button:hover {
            transform: scale(1.1);
          }

          @media (max-width: 1024px) {
            .slide-container {
              flex-direction: column;
              gap: 1.5rem;
              padding: 2rem;
            }

            .slide-text {
              font-size: 1rem;
              line-height: 1.4;
              max-width: 100%;
            }

            .slide-image {
              flex: 0 0 auto;
              max-width: 300px;
              height: auto;
            }

            .tenet-container {
              flex-direction: column;
              max-width: 100%;
            }

            .tenet-content,
            .tenet-image {
              max-width: 100%;
            }

            .tenet-content {
              padding: 1rem;
              font-size: 1rem;
            }
          }

          @media (max-width: 768px) {
            .slide-text {
              font-size: 0.9rem;
            }

            .slide-image {
              max-width: 250px;
            }

            .tenet-container {
              padding: 1rem;
            }

            .tenet-content {
              font-size: 0.9rem;
            }
          }

          @media (max-width: 480px) {
            .slide-text {
              font-size: 0.8rem;
            }

            .slide-image {
              max-width: 200px;
            }

            .tenet-content {
              font-size: 0.8rem;
              padding: 0.5rem;
            }

            .tenet-container {
              gap: 1rem;
            }
          }
        `}
      </style>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "calc(100% - 8rem)",
          height: "calc(100% - 8rem)",
          transform: "translate(-50%, -50%)",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          border: "2px solid rgba(255, 255, 255, 0.8)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "row",
          padding: "3rem",
          boxSizing: "border-box",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className={
            currentSlide === slides.length - 1 ? "" : "slide-content animate"
          }
          key={currentSlide}
        >
          {currentSlide < 2 ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "2rem",
                  padding: "1rem",
                }}
              >
                {/* Text Section */}
                <div style={{ flex: 1, color: "white", maxWidth: "45%" }}>
                  <h2
                    style={{
                      fontSize: "1.8rem",
                      fontWeight: "bold",
                      marginBottom: "1rem",
                    }}
                  >
                    {currentContent.title}
                  </h2>
                  {currentContent.description.map((text, index) => (
                    <p
                      key={index}
                      style={{ fontSize: "1.25rem", lineHeight: "1.5" }}
                    >
                      {text}
                    </p>
                  ))}
                </div>

                {/* Image Section */}
                <div
                  style={{
                    flex: "0 0 300px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={currentContent.image}
                    alt={currentContent.title}
                    style={{
                      width: "100%",
                      height: "350px",
                      maxWidth: "400px",
                      borderRadius: "10%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          ) : currentSlide === 2 ? (
            // Layout for the remaining slides
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                // textAlign: "center",
                color: "white",
              }}
            >
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  position: "absolute",
                  top: "50%",
                  left: "1.25rem",
                  transform: "translateY(-50%)",
                }}
                onClick={handlePrevious}
                onFocus={(e) => e.target.blur()}
              >
                <img
                  src="/assets/images/left-arrow1.png"
                  style={{ width: "50px", height: "50px" }}
                  alt="Previous"
                />
              </button>
              <div
                className="slide-container"
                style={{
                  maxWidth: "80%",
                }}
              >
                <h2
                  className="slide-text"
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}
                >
                  {currentContent.title}
                </h2>
                <p
                  className="slide-text"
                  style={{
                    fontSize: "1.5rem",
                    maxWidth: "80%",
                  }}
                >
                  {currentContent.description.join(" ")}
                </p>
              </div>
              <TenetContent tenet={tenets[currentTenetSlide]} />
            </div>
          ) : (
            // Layout for the last slide
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // Full viewport height ensures vertical centering
                margin: "0", // Removes default margin
                textAlign: "center", // Ensures text inside is centered
              }}
            >
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  position: "absolute",
                  top: "50%",
                  left: "1.5rem",
                  transform: "translateY(-50%)",
                  outline: "none",
                  boxShadow: "none", // Remove focus box shadow
                  WebkitTapHighlightColor: "transparent",
                }}
                onClick={handlePrevious}
                onFocus={(e) => e.target.blur()}
              >
                <img
                  src="/assets/images/left-arrow1.png"
                  style={{ width: "50px", height: "50px", display: "block" }}
                  alt="Previous"
                />
              </button>
              <p
                style={{
                  color: "white",
                  lineHeight: "1.5",
                  fontSize: "1.8rem", // Adjusted font size to match the styling
                  fontWeight: "bold", // Emphasize the heading
                  margin: "2rem auto",
                }}
              >
                I am ready!
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "2rem", // Create consistent spacing
                  padding: "1rem", // Add padding to the container
                }}
              >
                <button
                  onClick={() => setCurrentView("newComponent")}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "2rem", // Adjust spacing for consistency
                    padding: "0.8rem 2rem",
                    backgroundColor: "#FF5A5F",
                    color: "white",
                    fontSize: "1.15rem",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    lineHeight: "1",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add button shadow for consistency
                  }}
                >
                  Begin Simulation
                </button>
              </div>
            </div>
          )}

          {/* Navigation buttons */}
          {currentSlide > 0 && currentSlide !== 2 && (
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                position: "absolute",
                top: "50%",
                left: "1.5rem",
                transform: "translateY(-50%)",
              }}
              onClick={handlePrevious}
              onFocus={(e) => e.target.blur()}
            >
              <img
                src="/assets/images/left-arrow1.png"
                style={{ width: "50px", height: "50px" }}
                alt="Previous"
              />
            </button>
          )}

          {currentSlide < slides.length - 1 && (
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                position: "absolute",
                top: "50%",
                right: "1.5rem",
                transform: "translateY(-50%)",
              }}
              onClick={handleNext}
              onFocus={(e) => e.target.blur()}
            >
              <img
                src="/assets/images/right-arrow.png"
                style={{ width: "50px", height: "50px" }}
                alt="Next"
              />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SliderComponent;
